import axios from 'axios'
import {HashRouter} from 'react-router-dom'
const router = new HashRouter();
// http request 拦截器
axios.interceptors.request.use(
    config => {
        if(localStorage.getItem("storeToken")) {
            let token = localStorage.getItem("storeToken");
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (config.url.indexOf('oauth/login') < 0) {
            let uuid;
            const secret = localStorage.getItem('uuid');
            if (secret) {
                uuid = secret
            }
            config.data = {
                ...config.data,
                deviceId: uuid
            }
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 返回 401 清除token信息并跳转到登录页面
                    localStorage.removeItem("storeToken");
                    router.history.push('/Login')
            }
        }
        
        return Promise.reject(error.response)   // 返回接口返回的错误信息
    });

export default axios;
